/**
 * Calculate the luminance of a color to determine if text should be light or dark
 * @param hex - Hex color string (e.g., "#FFFF00")
 * @returns "white" | "black" - The recommended text color
 */
export function getTextColorForBackground(hex: string): "white" | "black" {
  const cleanHex = hex.replace("#", "")

  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  return luminance > 0.5 ? "black" : "white"
}

/**
 * Convert hex color to RGB values
 * @param hex - Hex color string
 * @returns RGB object
 */
export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const cleanHex = hex.replace("#", "")

  return {
    r: parseInt(cleanHex.slice(0, 2), 16),
    g: parseInt(cleanHex.slice(2, 4), 16),
    b: parseInt(cleanHex.slice(4, 6), 16),
  }
}
